export enum EventLatency {
  ThreeSix = '3-6s',
  SevenFifteen = '7-15s',
}
